<template lang="pug">
v-container(fluid fill-height)
  v-row(align="self-stretch")
    v-col(class="tw-relative")
      v-row(dense align="stretch" class="tw-self-start")
        v-col(cols="auto")
          v-img(
            :src="sampleWebsiteImage('houseExterior', 170, 130)"
            class="tw-border-blueGray-lighten-4 tw-border tw-rounded"
            max-width="180"
            contain
          )
        v-col(class="  d-flex flex-column")
          v-row(no-gutters)
            v-col
              v-row(dense)
                v-col
                  router-link(
                    class="tw-font-medium text-link"
                    :to="{ name: 'goodsItem', params: { id: this.$faker().datatype.number() } }"
                  )
                    span {{ this.$faker().address.streetAddress() }}
              v-row(dense)
                v-col
                  span {{ this.$faker().lorem.lines(2) }}
            v-col(cols="auto")
              v-menu(bottom left rounded="xl" nudge-bottom="40")
                template(v-slot:activator="{ on, attrs }")
                  v-btn(
                    :ripple="false"
                    depressed
                    v-on="on"
                    v-bind="attrs"
                    width="10px"
                    max-width="10"
                    min-width="10"
                    min-height="10"
                    max-height="30"
                    class="tw-border-gray-lighten-1 tw-p-0 tw-m-0"
                  )
                    v-icon(color="blue-grey darken-1 tw-p-0 tw-m-0") mdi-dots-horizontal
          v-row(no-gutters justify="center" align="end" align-content="stretch" class="d-flex flex-row flex-grow-1 ")
            v-col(cols="auto")
              v-btn-toggle(
                v-model="stage"
                mandatory
                borderless
                dense
                rounded
              )
                v-btn(depressed small color="rgba(94,129,244,0.10)")
                  span(class="tw-font-bold tw-text-kPurple") New
                v-btn(depressed small color="rgba(94,129,244,0.10)")
                  span(class="tw-font-bold tw-text-kPurple") Considering
                v-btn(depressed small color="rgba(94,129,244,0.10)")
                  span(class="tw-font-bold tw-text-kPurple") Discarded

      v-row(dense align="self-start")
        v-col(align="stretch")
          v-row(no-gutters align="center")
            v-col(cols="auto")
              span(class="tw-font-medium tw-text-sm tw-pr-2") Details
            v-col
              v-divider
          v-row(justify="space-around" class="tw-text-sm")
            v-col(cols="auto")
              div Single-Family Home
              div 256m2 lot size
              div 140m2 living space
            v-col(cols="auto")
              div 4 bedrooms
              div 3 bathrooms
              div 2 parking
            v-col(cols="auto")
              div Built in 1987
              div $250 /m2
      v-row(dense align-self="stretch" class="tw-self-stretch")
        v-col
          v-row(no-gutters align="center")
            v-col(cols="auto")
              span(class="tw-font-medium tw-text-sm tw-pr-2") Pitch notes
            v-col
              v-divider
          v-row
            v-col
              v-virtual-scroll(height="230" item-height="100" :items="notes")
                kubiqa-notes-list-item
      v-row(
        no-gutters
        align="center"
        justify="space-between"
        class=" tw-px-4  tw-bg-indigo-lighten-4 tw-bg-opacity-25 tw--mx-3 tw-self-end tw-absolute tw-w-full  tw-bottom-0 "
      )
        v-col
          v-input(hide-details)
            v-text-field(
              single-line
              dense
              solo
              full-width
              truncate-length="50"
              :clearable="false"
              show-size
              flat
              hide-details
              placeholder="Add note"
              background-color="transparent"
              class=" tw-text-kPurple tw-border-none"
            )
        v-col(cols="auto")
          v-btn(depressed color="rgba(94,129,244,0.80)") 
            |
            span(class="tw-font-bold") ADD
</template>

<script>
export default {
  data() {
    return {
      notes: [],
      stage: undefined,
    };
  },
  mounted() {
    for (let index = 0; index < 40; index++) {
      let note = {};
      note.text = this.$faker().lorem.lines(2);
      note.date = this.$moment(this.$faker().date.recent(3)).fromNow();
      this.notes.push(note);
    }
  },
};
</script>

<style lang="stylus">
.v-item--active
    background-color: #2f53c9 !important
    color: #ffffff !important

.v-item--active span, .v-item--active .v-icon
    color: #ffffff !important;
</style>
